import { render, staticRenderFns } from "./CustomTextArea.vue?vue&type=template&id=d3b2117c"
import script from "./CustomTextArea.vue?vue&type=script&lang=ts"
export * from "./CustomTextArea.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports